import { environment } from 'src/environments/environment';
import { Component, ElementRef, OnInit, ViewChild , Input} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { ErrorHandlingService } from 'src/app/core/services/error-handling.service';
import { HttpService } from 'src/app/core/services/api/http.service';
import { ProgressBarUpdatesService } from 'src/app/core/services/progress-bar-updates.service';
import { guideModules } from './guide-importing-modules';
import { Location } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DEFAULT_MAX_FILE_SIZE } from '../../consts/default-max-file-size.const';

type FortegraAmountMode = 'set' | 'add';

@Component({
  selector: 'app-import-records',
  templateUrl: './import-records.component.html',
  styleUrls: ['./import-records.component.css']
})
export class ImportRecordsComponent implements OnInit {

  showImport:boolean = environment.showImportFeature
  guidelinesModule:any;
  uploadForm!:FormGroup;
  fileInput:any;
  isUploaded:boolean=false;
  loadingSubmit:boolean=false;
  formDataPayLoad: any = new FormData();
  fileSize: any = DEFAULT_MAX_FILE_SIZE;
  photoAllowedExt: any =  ['.csv'];
  @ViewChild('attachedFile')  attachedFileEle!:ElementRef;
  showConfirmPopup:boolean = false;
  @ViewChild('messageComponent', {static: false}) messageComponent:any;

  currentModule:string = '';
  formats:any = [
    {name:'Spreadsheet(.csv)',key:'csv'},
    {name:'Page layout(.pdf)',key:'pdf'},
  ]

  amountModeOptions: { label: string; value: FortegraAmountMode }[] = [
    { label: 'Set (replace claim amount)', value: 'set' },
    { label: 'Add (add to claim amount)', value: 'add' },
  ];

  fileName:any;
  progressBarPopup: boolean = false;
  progressBarInfo:any;

  constructor(private _api: HttpService,
    private notificationService: NotificationsService,
    private errHandle: ErrorHandlingService,
    private router: Router,
    private route: ActivatedRoute,
    private _ProgressService:ProgressBarUpdatesService,
    private location:Location) { }

  ngOnInit(): void {
    this.currentModule = this.route.snapshot.params['module']
    this.guidelinesModule = guideModules[this.currentModule];
    if(!this.guidelinesModule){
      this.router.navigate(['/dashboard/import/products']);
      this.currentModule = 'products'
      this.guidelinesModule = guideModules[this.currentModule];
    }
    this.uploadForm = new FormGroup({
      records:new FormControl('',[]),
      format:new FormControl({name:'Spreadsheet(.csv)',key:'csv'},[]),
      is_fortegra_claim:new FormControl(false),
      is_uploaded_fortegra_claim:new FormControl(false),
      amount_mode:new FormControl<FortegraAmountMode>('set'),
    })
    if(this.currentModule === 'contracts'){
      this.fileSize = DEFAULT_MAX_FILE_SIZE;
    }

    this._ProgressService.getUpdatedProgressBarObservable().subscribe((data:any)=>{
      if(data?.module != 'rateModule'){
        setTimeout(()=>{
          this.progressBarPopup = data?.is_finished ? false : true;
        },2000)
        this.progressBarInfo = data;
      }
    })
    
    const savedProgressBarInfo = JSON.parse(localStorage.getItem('progressBarInfo')!) || null;

    if (savedProgressBarInfo?.module === this.currentModule) {
      this.progressBarInfo = savedProgressBarInfo || null;
    }

    if(this.progressBarInfo){
      this.progressBarPopup = true;
      if(this.progressBarInfo?.module != this.currentModule){
        this.messageComponent?.open();
      }
    }

  }


  fetchFile(){
    // if(this._ProgressService.getProgressInfo()?.id){
    //   this.notificationService.warn('','We are now processing the records. Please wait while we add them to the database.')
    //   return
    // }
    this.attachedFileEle.nativeElement.click();
  }

  deleteFile() {
    this.isUploaded = false;
    this.fileName = '';
    this.uploadForm.controls['records'].reset();
  }

  uploadImage(event:any){
    
    const file=event.target.files[0];
    //check if file exist
    if(file){
      //if valid file load in design
      if(this.uploadForm.controls['records'].valid){ 
        this.formDataPayLoad?.delete('file');
        this.isUploaded=true;
        const reader=new FileReader();
        this.formDataPayLoad.append('file',file);
        reader.readAsDataURL(file);
        reader.onload=(e:any)=>{
          // this.messageComponent.open();
          this.fileName = file?.name;
        }
      }else{
        // reset all attributes
        this.isUploaded = false;
        this.uploadForm.controls['records'].markAsTouched();
      }
    }else{
    }

  }



  save(){
    if(this.uploadForm.invalid || !this.uploadForm.dirty){
      this.uploadForm.markAllAsTouched();
      return
    }
    this.loadingSubmit = true;
    if(this.currentModule === 'fortegra-claims'){
      this.formDataPayLoad.delete('customData');
      const customData = {
        is_fortegra_claim: this.uploadForm.value.is_fortegra_claim || false,
        is_uploaded_fortegra_claim: this.uploadForm.value.is_uploaded_fortegra_claim || false,
        amount_mode: this.uploadForm.value.amount_mode || 'set',
      };
      this.formDataPayLoad.append('customData', JSON.stringify(customData));
    }
    this._api.postReq(this.guidelinesModule?.endpoint,this.formDataPayLoad).subscribe(res=>{
      this.loadingSubmit = false;
      this.isUploaded = false;
      this.notificationService.success('',res?.message);
      // set progress data info to local storage
      let progressInfo:any = {
        id:res?.data?.batchId,
        value:0,
        is_finished:false,
        module:this.currentModule
      }
      localStorage.setItem("progressBarInfo",JSON.stringify(progressInfo));
      this._ProgressService.invokeUpdatedProgressBar(progressInfo);
      this._ProgressService.setIntervalTimeFun();
    },err=>{
      this.errHandle.errorHandling(err);
      this.loadingSubmit = false;
    })
  }

  rejected(){
    // this.showConfirmPopup = false;
    this.messageComponent.close();
    this.router.navigate(['/dashboard/import/'+this.progressBarInfo?.module])
  }

  accepted(){
    this.cancelBatch();
  }

  back(){
    this.location.back();
  }

  cancelBatch(){
    this.loadingSubmit = true;
    this._api.deleteReq(`/batch/${this.progressBarInfo?.id}`).subscribe(res=>{
      this.loadingSubmit = false;
      this.notificationService.success('',res?.message);
      // remove progress data info to local storage
      this._ProgressService.removeSetIntervalTime();
      this.progressBarInfo = '';
      this.progressBarPopup = false;
      this.messageComponent.close();
    },err=>{
      this.errHandle.errorHandling(err);
      this.loadingSubmit = false;
    })
  }

}
